module.exports = __webpack_public_path__ + "img/40_38_077_260.4e9846db.jpg";